import { GuidEmpty } from 'mbs-ui-kit';
import { ScheduleStepValue } from 'mbs-ui-shared@models/backup/schedule-models';
import { RecurringSchedule } from 'mbs-ui-shared@models/ScheduleModel';
import moment from 'moment/moment';
import { Storages } from 'wizards/models/base/base-models/plan-storages-model';
import { CompressionEncryptionStepValue } from 'wizards/models/compression-encription-models';
import { ScheduleAdvancedStepValue, ScheduleFormSettings } from 'wizards/models/schedule-advanced-models';
import { WhereBackupStepValue } from 'wizards/models/where-backup-models';

export class ConsistencyCheckModel {
  public date = moment(new Date()).toDate();
  public time = moment(this.date).format('HH:mm:ss');

  whereBackupStep: WhereBackupStepValue = { IsHybridBackup: false, HybridID: GuidEmpty, ConnectionID: GuidEmpty, valid: false };
  Storages: Storages = { CloudStorages: [], LocalStorages: [] };
  compressionEncryptionStep: CompressionEncryptionStepValue = {
    skipLegacy: true,
    UseEncryption: false,
    EncryptionPassword: '',
    valid: true
  };
  scheduleStep: ScheduleStepValue = {
    ScheduleType: 'noschedule',
    specificDateGroup: { date: this.date, time: this.time },
    StopAfterEnabled: false,
    stopAfterHours: 0,
    stopAfterMinutes: 0,
    ForceMissedSchedule: false,
    overdueAfterSuccessEnabled: false,
    overdueAfterSuccessAmount: 7,
    overdueAfterSuccessPeriod: 1,
    syncBeforeRun: false,
    valid: true
  };
  scheduleAdvancedStep?: ScheduleAdvancedStepValue = {
    forceFull: new ScheduleFormSettings(false, new RecurringSchedule(false)),
    blockLevel: new ScheduleFormSettings(null, null),
    scheduleDiff: new ScheduleFormSettings(null, null),
    scheduleTLog: new ScheduleFormSettings(null, null),
    valid: true
  };

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  constructor() {}
}
